import DocumentTemplateEditBlock from 'components/_dashboardPagesFeatures/documentTemplate/DocumentTemplateEditBlock';
import LoaderComponent from 'components/ui/loadingIndicators/LoaderComponent';
import useDI from 'hooks/useDI';
import useInitializePage from 'hooks/useInitializePage';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { RoutingServiceDashboard } from 'services/routing/RoutingService';
import { useSelector } from 'storage';

function EnterpriseDocumentTemplateEditPage() {
  const { services } = useDI();
  const { translate } = services.language;
  const pathParams = useParams();
  const { permissions } = useSelector((state) => state.auth);
  const { enterprise, enterpriseIsLoading } = useSelector((state) => state.enterprise);
  const { documentTemplate, documentTemplateIsLoading } = useSelector((state) => state.documentTemplate);
  const { storageActions } = useDI();

  useEffect(() => {
    if (pathParams.documentTemplateId && pathParams.documentTemplateId !== 'new') {
      storageActions.models.documentTemplate.getById(pathParams.documentTemplateId);
    }
  }, [pathParams.documentTemplateId]);

  const isPageInitialized = useInitializePage(() => {
    const menu: MenuIconItemData[] = [];
    const breadcrumbs = RoutingServiceDashboard.modelsDirectory.documentTemplate.getInstanceChildBc(pathParams, permissions, translate, {
      enterpriseName: enterprise?.name || '',
      documentTemplate: documentTemplate?.name || '',
    });
    const title = `${translate('pages.documentTemplate.editPageTitle')} ${documentTemplate?.name || ''}`;
    return { breadcrumbs, menu, title };
  }, [enterpriseIsLoading, documentTemplateIsLoading]);

  if (!isPageInitialized || documentTemplateIsLoading) return <LoaderComponent />;

  if (!documentTemplate) {
    return <div>{translate('pages.documentTemplate.notFound')}</div>;
  }
  return <DocumentTemplateEditBlock documentTemplate={documentTemplate} />;
}

export default React.memo(EnterpriseDocumentTemplateEditPage, () => true);
